import { applyFocusVisible, directionSwitch, ellipsis, format, important, toPx, } from "@microsoft/fast-jss-utilities";
import { applyCornerRadius, applyFocusPlaceholderBorder } from "../utilities/border";
import { neutralFillStealthHover, neutralFillStealthRest, neutralFillStealthSelected, neutralFocus, neutralForegroundRest, } from "../utilities/color";
import { applyCursorDefault, applyCursorPointer } from "../utilities/cursor";
import { glyphSize, height, horizontalSpacing } from "../utilities/density";
import { designUnit, focusOutlineWidth } from "../utilities/design-system";
import { applyDisabledState } from "../utilities/disabled";
import { applyScaledTypeRamp } from "../utilities/typography";
import { HighContrastColor, highContrastDisabledBorder, highContrastOutlineFocus, highContrastSelected, highContrastSelector, highContrastStealth, } from "../utilities/high-contrast";
const styles = {
    selectOption: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ "list-style-type": "none", "box-sizing": "border-box", height: height(), display: "flex", "align-items": "center", padding: format("0 {0}", horizontalSpacing(focusOutlineWidth)), margin: format("0 {0}", toPx(designUnit)), color: neutralForegroundRest, fill: neutralForegroundRest, "white-space": "nowrap", overflow: "hidden" }, applyCursorDefault()), applyScaledTypeRamp("t7")), { background: neutralFillStealthRest }), applyCursorPointer()), applyCornerRadius()), applyFocusPlaceholderBorder()), applyFocusVisible(Object.assign({ "border-color": neutralFocus }, highContrastOutlineFocus))), { "&:hover": Object.assign({ background: neutralFillStealthHover }, highContrastSelected) }), highContrastStealth),
    selectOption_contentRegion: Object.assign({ overflow: "hidden" }, ellipsis()),
    selectOption_glyph: {
        display: "inline-block",
        position: "relative",
        width: glyphSize,
        height: glyphSize,
        "flex-shrink": "0",
        margin: directionSwitch(format("0 {0} 0 0", horizontalSpacing()), format("0 0 0 {0}", horizontalSpacing())),
    },
    selectOption__disabled: Object.assign(Object.assign(Object.assign({}, applyDisabledState()), highContrastDisabledBorder), { "&, &:hover": {
            background: neutralFillStealthRest,
        } }),
    selectOption__selected: {
        [highContrastSelector]: {
            background: important(HighContrastColor.selectedBackground),
            "border-color": important(HighContrastColor.buttonText),
            color: important(HighContrastColor.selectedText),
            fill: important(HighContrastColor.selectedText),
        },
        background: neutralFillStealthSelected,
        "&:hover": {
            background: neutralFillStealthSelected,
        },
    },
};
export default styles;
